import { dispatchAppLogout } from "../state/dispatchAppLogout";

const useAppLogout = () => {
    return (dispatch: any) => dispatchAppLogout(dispatch);
};

export default useAppLogout;